import { gql } from '@apollo/client';

export const GET_PRICE_SYNC_QUEUE_STATS = gql(/* GraphQL */ `
    query GetPriceSyncQueueStats {
        getPriceSyncQueueStats {
            pending
            sending
            failedRetryable
            failedExhausted
            sentLast24h
            integrationEnabled
        }
    }
`);

export const GET_PRICE_SYNC_QUEUE_ROWS = gql(/* GraphQL */ `
    query GetPriceSyncQueueRows(
        $status: PriceSyncStatus
        $storeNo: String
        $sku: String
        $take: Int
        $skip: Int
    ) {
        getPriceSyncQueueRows(
            status: $status
            storeNo: $storeNo
            sku: $sku
            take: $take
            skip: $skip
        ) {
            rows {
                id
                productId
                storeNo
                sku
                status
                attempts
                lastError
                lastTriggeredAt
                sentAt
                createdAt
            }
            total
        }
    }
`);

export const GET_PRICE_SYNC_QUEUE_ROW_DETAIL = gql(/* GraphQL */ `
    query GetPriceSyncQueueRowDetail($queueId: String!) {
        getPriceSyncQueueRowDetail(queueId: $queueId) {
            id
            productId
            storeNo
            sku
            status
            attempts
            lastError
            lastTriggeredAt
            sentAt
            createdAt
            updatedAt
            futurePrices {
                type
                price
                currency
                validFrom
                validTo
            }
        }
    }
`);
